import React from 'react'
import styles from './SignupStepPublicEdit.module.scss'
import { Button } from 'components/Button/Button'
import { FormEdit } from 'components/PopupEditPage/EditPage/FormEdit/FormEdit'
import { COLORS_DATA } from 'components/PopupEditPage/EditPage/FormEdit/consts'


type Props = {
    onSubmit?: () => void,
}

export function SignupStepPublicEdit(props: Props) {
    const [data, setData] = React.useState({
        file: null,
        name: 'hello',
        link: '',
        about: 'some about info',
        twitter: null,
        instagram: 'testinst',
        facebook: null,
        defaultColor: COLORS_DATA[1].value,
        patrons: '850',
        drizzles: '13k'
    })

    function handleSubmit() {
        props.onSubmit()
    }

    function handleChange(data) {
        console.log('data', data)
        // add code handle credentials
    }

    return (
        <div className={styles['wrapper']}>
            <FormEdit
                title='Set up your page'
                data={data}
                onChange={handleChange}
            />
            <div className={styles['button']}>
                <Button
                    size='m'
                    type='dark'
                    iconName='forward'
                    iconRight
                    onClick={handleSubmit}
                >
                    Continue
                </Button>
            </div>
        </div >
    );
}

